// Import styles
import 'primeflex/primeflex.css';
// Import styles
import 'app/components/app/navigation/navigation.scss';
import 'app/components/app/navigation/quick-actions/quick-actions.scss';
import 'styles/diagnotize.scss';
import 'styles/staticsite/_index.scss';

// Configure enumerators
import { configureGeographies } from 'lib/models/diagnoses/choices/epidemiology/geography';
import { configureLocalizedFindings } from 'lib/models/diagnoses/choices/localized-findings/parser';
import { configureTopics } from 'lib/models/diagnoses/choices/topic';
configureTopics((window as any).preloaded.enums.topics);
configureGeographies((window as any).preloaded.enums.geographies);
configureLocalizedFindings((window as any).preloaded.enums.localized);

// Configure API
import { BaseAPI } from 'lib/api/base/base-api';
BaseAPI.setRoot('/api');

// Configure Luxon
import { Settings } from 'luxon';
Settings.defaultLocale = 'en-UK';

// Mount application
import { startSearchApplication } from './application.search';
setTimeout(startSearchApplication, 0);
